"use client";

import React, { useContext, useEffect, useState } from "react";
// import SearchMapIconReq from '../../../../Requests/MapIcon/SearchMapIconReq'
// import MapIconApi from '../../../../API/MapIconApi'
import { CircularProgress } from "@mui/material";
import { MapContext } from "..";
import { Box, Tab, Tabs } from "@mui/material";
import { UserContext } from "../../../../App";
import "./Legends.scss";
import MapIconApi from "../../../../API/MapIconApi";
const Legends = () => {
  // const [loading, setLoading] = React.useState(false)4
  const [activeTab, setActiveTab] = React.useState(0);
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  const user = useContext(UserContext);
  const map = useContext(MapContext);
  // Add a state to hold map icons
  const [mapIcons, setMapIcons] = useState([]);

  // Fetch the map icons from the API on component mount
  useEffect(() => {
    const fetchMapIcons = async () => {
      try {
        const res = await MapIconApi.GetAllMapIcons(); // Fetch map icons
        setMapIcons(res); // Set the map icons state
      } catch (error) {
        console.error("Error fetching map icons", error);
      }
    };

    fetchMapIcons();
  }, []);

  return (
    <div className="legend_container">
      <h1>Lead Types</h1>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="create lead tabs"
        >
          <Tab label="Lead MapIcons" />
          {user.userType === "SuperAdmin" && <Tab label="Company MapIcons" />}
          {user.userType === "SuperAdmin" && <Tab label="Recruit MapIcons " />}
        </Tabs>
      </Box>

      <Box role="tabpanel" hidden={activeTab !== 0}>
        {activeTab === 0 && map.mapIcons.length > 0 ? (
          <div className="lead_types_grid_container">
            <div className="lead_types_card">
              <h2>KEY LEAD DISPOSITIONS</h2>
              <div className="lead_types_list">
                {map.mapIcons
                  .filter(
                    (icon) => icon.iconType == null && icon.isKeyDisposition
                  )
                  .map((icon, index) => (
                    <div className="icon_item" key={index}>
                      <div className="icon_wrapper">
                        <img
                          alt="map_icon"
                          src={"data:image/png;base64," + icon.image}
                        />
                      </div>
                      <p>{icon.name}</p>
                    </div>
                  ))}
              </div>
              <h2 style={{ marginTop: "1rem" }}>OTHER LEAD DISPOSITIONS</h2>
              <div className="lead_types_list">
                {map.mapIcons
                  .filter(
                    (icon) =>
                      icon.iconType == null && icon.isOtherLeadDisposition
                  )
                  .map((icon, index) => (
                    <div className="icon_item" key={index}>
                      <div className="icon_wrapper">
                        <img
                          alt="map_icon"
                          src={"data:image/png;base64," + icon.image}
                        />
                      </div>
                      <p>{icon.name}</p>
                    </div>
                  ))}
              </div>
            </div>
            
            <div className="lead_types_card">
              <h2>NEW LEAD STATUSES (FIBER, HFC, MDU, ETC.)</h2>
              <div className="lead_types_list">
                {map.mapIcons
                  .filter((icon) => icon.iconType == null && icon.isNewLead)
                  .map((icon, index) => (
                    <div className="icon_item" key={index}>
                      <div className="icon_wrapper">
                        <img
                          alt="map_icon"
                          src={"data:image/png;base64," + icon.image}
                        />
                      </div>
                      <p>{icon.name}</p>
                    </div>
                  ))}
              </div>
            </div>

            <div className="lead_types_card">
              <h2>MORE LEAD DISPOSITIONS (ISP COMPETITORS)</h2>
              <div className="lead_types_list">
                {map.mapIcons
                  .filter((icon) => icon.iconType == null && icon.isCompetition)
                  .map((icon, index) => (
                    <div className="icon_item" key={index}>
                      <div className="icon_wrapper">
                        <img
                          alt="map_icon"
                          src={"data:image/png;base64," + icon.image}
                        />
                      </div>
                      <p>{icon.name}</p>
                    </div>
                  ))}
              </div>
            </div>

            

            <div className="lead_types_card">
              <h2>KEY CUSTOMER STATUSES</h2>
              <div className="lead_types_list">
                {map.mapIcons
                  .filter(
                    (icon) => icon.iconType == null && icon.isKeyCustomerStatus
                  )
                  .map((icon, index) => (
                    <div className="icon_item" key={index}>
                      <div className="icon_wrapper">
                        <img
                          alt="map_icon"
                          src={"data:image/png;base64," + icon.image}
                        />
                      </div>
                      <p>{icon.name}</p>
                    </div>
                  ))}
              </div>
              <h2 style={{ marginTop: "1rem" }}>OTHER CUSTOMER STATUSES</h2>
              <div className="lead_types_list">
                {map.mapIcons
                  .filter(
                    (icon) =>
                      icon.iconType == null && icon.isOtherCustomerStatus
                  )
                  .map((icon, index) => (
                    <div className="icon_item" key={index}>
                      <div className="icon_wrapper">
                        <img
                          alt="map_icon"
                          src={"data:image/png;base64," + icon.image}
                        />
                      </div>
                      <p>{icon.name}</p>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <CircularProgress
              size={50}
              sx={{
                color: "var(--primary-color)",
              }}
            />
          </div>
        )}
      </Box>
      <Box role="tabpanel" hidden={activeTab !== 1}>
        {activeTab === 1 && map.mapIcons.length > 0 ? (
          <div className="map_icons">
            {map.mapIcons.map((icon, index) => {
              if (icon.iconType === "Company") {
                return (
                  <div className="icon" key={index}>
                    <img
                      alt="map_icon"
                      style={{
                        width: "2rem",
                        height: "2rem",
                      }}
                      src={"data:image/png;base64," + icon.image}
                    />
                    <p>{icon.name}</p>
                  </div>
                );
              }
            })}
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <CircularProgress
              size={50}
              sx={{
                color: "var(--primary-color)",
              }}
            />
          </div>
        )}
      </Box>

      <Box role="tabpanel" hidden={activeTab !== 2}>
        {activeTab === 2 && map.mapIcons.length > 0 ? (
          <div className="map_icons">
            {map.mapIcons.map((icon, index) => {
              if (icon.iconType === "Recruit") {
                return (
                  <div className="icon" key={index}>
                    <img
                      alt="map_icon"
                      style={{
                        width: "2rem",
                        height: "2rem",
                      }}
                      src={"data:image/png;base64," + icon.image}
                    />
                    <p>{icon.name}</p>
                  </div>
                );
              }
            })}
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <CircularProgress
              size={50}
              sx={{
                color: "var(--primary-color)",
              }}
            />
          </div>
        )}
      </Box>
    </div>
  );
};

export default Legends;
